var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeddingWire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51901 7.62719C9.07438 7.62719 9.52459 7.17698 9.52459 6.62161C9.52459 6.06624 9.07438 5.61603 8.51901 5.61603C7.96364 5.61603 7.51343 6.06624 7.51343 6.62161C7.51343 7.17698 7.96364 7.62719 8.51901 7.62719Z",
    fill: "#13B3BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5189 5.25558C9.20001 5.25558 9.75216 4.70343 9.75216 4.02232C9.75216 3.34121 9.20001 2.78906 8.5189 2.78906C7.83779 2.78906 7.28564 3.34121 7.28564 4.02232C7.28564 4.70343 7.83779 5.25558 8.5189 5.25558Z",
    fill: "#13B3BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 4.17412C11.0235 4.17412 10.4543 4.72434 10.4543 5.40738C10.4543 5.82479 10.682 6.18528 10.9666 6.41296C9.99892 7.57033 9.25896 8.97435 8.80361 10.5112V8.10158H8.29133V10.4732C7.85495 8.9364 7.09602 7.51341 6.14736 6.39399C6.48887 6.16631 6.65963 5.80582 6.65963 5.38841C6.65963 4.72435 6.10941 4.15515 5.42637 4.15515C4.74334 4.15515 4.19312 4.70537 4.19312 5.38841C4.19312 6.07145 4.74334 6.62167 5.42637 6.62167C5.46432 6.62167 5.54021 6.62167 5.57816 6.62167C7.28575 8.51899 8.32928 11.346 8.29133 14.211H8.80361C8.76566 11.346 9.80919 8.51899 11.5168 6.62167C11.5547 6.62167 11.6306 6.62167 11.6686 6.62167C12.3326 6.62167 12.9018 6.07145 12.9018 5.38841C12.8639 4.72435 12.3516 4.17412 11.6875 4.17412Z",
    fill: "#13B3BA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51897 0.531253C12.9018 0.531253 16.4688 4.09822 16.4688 8.48103C16.4688 12.8638 12.9018 16.4498 8.51897 16.4498C4.13616 16.4498 0.550223 12.8638 0.550223 8.48103C0.550223 4.09822 4.13616 0.531253 8.51897 0.531253ZM8.51897 0C3.83259 0 0 3.79465 0 8.51898C0 13.2433 3.83259 17 8.51897 17C13.2054 17 17.0379 13.2054 17.0379 8.48103C17.0379 3.7567 13.2433 0 8.51897 0Z",
    fill: "#13B3BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeddingWire);
export default __webpack_public_path__ + "static/media/wedding-wire.6d279860c297b62a556ba4871bd82b23.svg";
export { ForwardRef as ReactComponent };